import { getTrafficType } from "../../Helpers/trafficType";
import { getPlatformVersion } from "../../Helpers/getPlatformVersion";
import { WhitelabelConfig } from "@/whitelabel/helpers/types";
import { removeUndefinedKeys } from "../../Helpers/removeUndefinedKeys";

export const getPageType = () => {
  if (typeof window === "undefined") return "bkFlow";

  const path = window.location.pathname;
  const hasNoSearchParams = window.location.search === "";

  if (
    hasNoSearchParams &&
    (path.includes("-did_") ||
      path.includes("-did_A") ||
      path.includes("hotel/") ||
      path.includes("gutschein/einloesung"))
  ) {
    return "content";
  }

  return "bkFlow";
};

interface PageTrackingParams {
  WlConfig: WhitelabelConfig | null;
  section: string;
  noResults?: string;
  additionalParams?: Record<string, any>;
  platformName?: string;
  trafficType?: string;
}

export const getPageTrackingData = ({
  WlConfig,
  section,
  platformName = "ICARUS", // should be SUNRISE for biff to work
  additionalParams = {},
}: PageTrackingParams) => {
  if (!WlConfig) return;
  const { whitelabelName, brand, locale } = WlConfig.platformDataTracking;

  let page: {
    brand: string;
    category: string;
    locale: string;
    platformName: string;
    platformVersion: string;
    section: string;
    type: string;
    trafficType: string;
    whitelabelName?: string;
  } = {
    brand,
    category: "to",
    locale,
    platformName,
    platformVersion: getPlatformVersion(),
    section: `to.${section}`,
    type: getPageType(),
    trafficType: getTrafficType(),
    ...removeUndefinedKeys(additionalParams),
  };
  if (whitelabelName && whitelabelName !== "lastminute") {
    page = {
      ...page,
      whitelabelName,
    };
  }

  return page;
};
